/**
 * Types
 */
export const Types = {
  GET_ME_RESPONSE: "user/GET_ME_RESPONSE",
  CHANGE_TAB: "user/CHANGE_TAB",
  RESET: "RESET"
};

/**
 * Reducers
 */
const INITIAL_STATE = {
  response: {},
  tabSelectedMobile: 1,
  editName: false,
  lapidarToken: "",
  acceptPolicy: false,
  acceptLgpd: false
};

/**
 * Actions
 */
export const Creators = {
  getResponse: (data) => ({
    type: Types.GET_ME_RESPONSE,
    response: data,
  }),
  changeMobileTab: (tabSelectedMobile) => ({
    type: Types.CHANGE_TAB,
    tabSelectedMobile
  })
};

export default function userReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_ME_RESPONSE:
      return {
        ...state,
        response: action.response,
      };
    case Types.CHANGE_TAB: 
      return {
        ...state,
        tabSelectedMobile: action.tabSelectedMobile,
        editName: false
    };
    case Types.RESET:
      return {
        response: {},
        tabSelectedMobile: 1,
        editName: false
      }
    case "SET_TOKEN": 
      return {
        ...state,
        lapidarToken: action.lapidarToken
      }
    case "SET_POLICY": 
      return {
        ...state,
        acceptPolicy: action.acceptPolicy
      }
    case "SET_LGPD": 
      return {
        ...state,
        acceptLgpd: action.acceptLgpd
      }
    default:
      return state;
  }
}
